import { Colors } from '@/components/common';

const appointmentStatusCodes = {
  coordinated: 1,
  canceledDe: 2,
  canceledProv: 3,
  completed: 4,
  denied: 6,
  extended: 8,
  confirmed: 9,
};

const getAppointmentStatusColor = (statusCd, isHexColor = true) => {
  switch (statusCd) {
    case appointmentStatusCodes.coordinated:
      return isHexColor ? '#FCC9C8' : Colors.PINK;

    case appointmentStatusCodes.canceledDe:
    case appointmentStatusCodes.canceledProv:
      return isHexColor ? '#D5B899' : Colors.BROWN;

    case appointmentStatusCodes.completed:
      return isHexColor ? '#F8EA80' : Colors.YELLOW;

    case appointmentStatusCodes.denied:
      return isHexColor ? '#DDB3D7' : Colors.PINK;

    case appointmentStatusCodes.extended:
      return isHexColor ? '#FF7058' : Colors.ORANGE;

    case appointmentStatusCodes.confirmed:
      return isHexColor ? '#A4E5B2' : Colors.GREEN_LIGHT;

    default:
      return isHexColor ? '#808080' : Colors.GRAY;
  }
};

export { appointmentStatusCodes, getAppointmentStatusColor };
